import { toast } from "react-toastify";
import { azureFetch } from "../../../api/azureFetch";

export const handleCheckboxSelection = (row, selectedRows, setSelectedRows) => e => {
    const isRowChecked = e.target.checked;
    if (isRowChecked) {
        const nextSelectedRows = [...selectedRows];
        nextSelectedRows.push(row);
        setSelectedRows(nextSelectedRows);
        return;
    }
    const filteredSelectedRows = selectedRows.filter(({ id }) => row.id !== id);
    setSelectedRows(filteredSelectedRows);
};

export const isRowSelected = (selectedRows, currentRow) => {
    const selectedRowIds = selectedRows.map(({ id }) => id);
    return selectedRowIds.includes(currentRow?.id);
};

export const handleAllRowsSelection = (e, selectedRows, setSelectedRows, alertsData) => {

    const currentPageSelectedRowIds = selectedRows.reduce((selectedRowIds, selectedRow) => {
        const matchedAlertsRow = alertsData.alertsList.find(alertsRow => alertsRow.id === selectedRow.id);
        if (matchedAlertsRow) {
            selectedRowIds.push(matchedAlertsRow.id);
        }
        return selectedRowIds;
    }, []);

    if (e.target.checked) {
        const nextSelectedRows = [...selectedRows];
        alertsData.alertsList.forEach(alertsRowData => {
            const isRowAlreadyPresent = currentPageSelectedRowIds.includes(alertsRowData.id);
            const isRowDisabled = alertsRowData.status === "READ"; // Disable selection for READ alerts
            if (!isRowAlreadyPresent && !isRowDisabled) {
                nextSelectedRows.push(alertsRowData);
            }
        });
        setSelectedRows(nextSelectedRows);
        return;
    }

    const nextSelectedRows = selectedRows.filter(selectedRow => !currentPageSelectedRowIds.includes(selectedRow.id));
    setSelectedRows(nextSelectedRows);
};

export const getCheckboxHeaderState = (alertsData, selectedRows) => {
    // Filter out rows with status "READ" as they cannot be selected
    console.log("getCheckboxHeaderState called with:", {alertsData, selectedRows});
    const selectableRowIds = alertsData?.alertsList?.filter(({ status }) => status !== "READ")
        .map(({ id }) => id);

    const selectedSelectableIds = selectedRows.filter(({ id }) => selectableRowIds.includes(id));

    return {
        isChecked: selectedSelectableIds.length === selectableRowIds.length,
        isIndeterminate: selectedSelectableIds.length !== selectableRowIds.length && selectedSelectableIds.length !== 0,
    };
};


export const resolveAlerts = (selectedRows, actionKey, refreshData) => {
    azureFetch("updateAlertStatusFromReport", {
        alert_ids: selectedRows.map(row => row.id),
        status: actionKey
    }).then(response => {
        console.log("Response from updateAlertStatus:", response);
        if (response.message === "Success") {
            toast.success("Alert status updated successfully");
            refreshData();
        } else {
            toast.error("Error updating alert status");
        }
    }).catch((error) => {
        console.error("Error updating alert status:", error);
        toast.error("Error updating alert status");
    });
};

export const addComments = (selectedRows, userComment, refreshData, handleModalClose, setUserComment) => {
    azureFetch("add_comments_alert_report", {
        alert_ids: selectedRows.map(row => row.id),
        comments: userComment
    }).then(response => {
        console.log("Response from addCRComments:", response);
        if (response.message === "Success") {
            toast.success("Comments added successfully");
            setUserComment("");
            refreshData();
        } else {
            toast.error("Error adding comments");
        }
    }).catch((error) => {
        console.error("Error adding comments:", error);
        toast.error("Error adding comments");
    });
    handleModalClose();
};

export const addCRComments = (selectedRows, userComment, refreshData, handleModalClose, setUserComment) => {
    azureFetch("add_comments", {
        alert_ids: selectedRows.map(row => row.id),
        comments: userComment
    }).then(response => {
        console.log("Response from addCRComments:", response);
        if (response.message === "Success") {
            toast.success("Comments added successfully");
            refreshData();
        } else {
            toast.error("Error adding comments");
        }
    }).catch((error) => {
        console.error("Error adding comments:", error);
        toast.error("Error adding comments");
    });
    handleModalClose();
};

export const resolveCRAlerts = (selectedRows, actionKey, refreshData) => {
    console.log("resolveCRAlerts called with:", {selectedRows, actionKey});
    azureFetch("updateAlertStatus", {
        alert_ids: selectedRows.map(row => row.id),
        status: actionKey
    }).then(response => {
        console.log("Response from updateAlertStatus:", response);
        if (response.message === "Success") {
            toast.success("Alert status updated successfully");
            refreshData();
        } else {
            toast.error("Error updating alert status");
        }
    }).catch((error) => {
        console.error("Error updating alert status:", error);
        toast.error("Error updating alert status");
    });
};